import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

const Feature = ({ customIconStyle = '', customTitleStyle = '', header, list, media }) => (
  <div className={ 'premium-features__item' }>
    <div className={ 'premium-features__content' }>
      <i aria-hidden='true' className={ `premium-features__icon ${customIconStyle}` } />
      <div className={ `premium-features__title ${customTitleStyle}` }><NewLineToBr>{header}</NewLineToBr></div>
      <ul className={ 'premium-features__list' }>
        {list && list.map((element, index) => (
          <li key={ index }>{element}</li>
        ))}
      </ul>
    </div>
    {media()}
  </div>
);

const NewLineToBr = ({ children = '' }) => {
  return children.split('\n').reduce(function(arr, line, index) {
    return arr.concat(
      line,
      <br key={ index } />
    );
  }, []);
};

Feature.propTypes = {
  customIconStyle: PropTypes.string,
  customTitleStyle: PropTypes.string,
  header: PropTypes.string.isRequired,
  list: PropTypes.instanceOf(Immutable.List),
  media: PropTypes.func
};

export default Feature;



// WEBPACK FOOTER //
// ./app/components/reps/premium/Feature.jsx